/* eslint-disable react/prop-types */
import React from 'react';
import { Paper } from 'components';
import { Typography } from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(styles);

const Card = (props) => {
  const { title, alert, icon, bgColor } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.root} onClick={props.onClick}>
      <div className={classes.content}>
        <div>
          <Typography variant="body2" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="h3" className={classes.value}>
            {alert}
          </Typography>
        </div>
        <div
          className={classes.iconWrapper}
          style={{ backgroundColor: bgColor }}
        >
          {icon}
        </div>
      </div>
    </Paper>
  );
};

export default Card;
